import React from "react";
import { useContext, useEffect } from "react";
import Contexto from "../context/Contexto";
import "../assets/css/Header.css";
import Logo from "../assets/statics/ds-logo.png";
import Menu from "../assets/CCstatics/MENU.svg";

import MobileMenu from "./MobileMenu";
import ImgEntrar from "./ImgEntrar";
import { useState } from "react";
import ImgCarrito from "./ImgCarrito";
import { Link } from "react-router-dom";

import toast, { Toaster } from "react-hot-toast";
//const notify = () => toast("Here is your toast.");
import { useLocation } from "react-router-dom";
// #ABFF24 Verde DS
// #FD83FF rosa DS
function Header() {
  const location = useLocation();

  const [fueraHome, setFueraHome] = useState(false);

  const {
    loguearUsuario,
    mensajes,
    mandarMensajes,
    Griseado,
    usuario,

    cliente,
    seteos,
  } = useContext(Contexto);
  useEffect(() => {
    window.onscroll = function () {
      myFunction();
    };

    // Get the header
    var header = document.getElementById("myHeader");

    // Get the offset position of the navbar
    var sticky = header.offsetTop;
    function myFunction() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }
  }, []);

  useEffect(() => {
    if (mensajes.mensaje != "") toast(mensajes.mensaje);
  }, [mensajes]);

  const [estado, setEstado] = useState(null);
  const [designSeason, setDesignSeason] = useState(false);
  const [fecha, setFecha] = useState("");
  const toggleMenu = () => {
    if (estado === "MenuOff" || estado === null) {
      setEstado("MenuOn");
    } else if (estado === "MenuOn") {
      setEstado("MenuOff");
    }
  };
  // useEffect(() => {
  //   if (seteos) {
  //     setFecha(seteos.home.fecha);
  //     setFueraHome(seteos.home.hayOfertas);
  //     console.log("setFueraHome", seteos.home.hayOfertas);
  //   }
  // }, [seteos]);

  // useEffect(() => {
  //   if (seteos && !seteos.home.hayOfertas) {
  //     if (location.pathname !== "/") {
  //       setFueraHome(true);
  //     } else {
  //       setFueraHome(false);
  //     }
  //   }

  //   if (location.pathname == "/designseason") {
  //     setDesignSeason(true);
  //   }
  // }, [location.pathname]);
  return (
    <>
      <Toaster position="bottom-right" id="heyDevBot" />

      {/* <div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div> 
      
       className={!designSeason ? "header" : "header designStyle"}
       
       */}

      <header className="header" id="myHeader">
        <p className="borrar">.</p>

        <Link
          to="https://www.colorclub.online/design-season"
          className="logoLink"
          onClick={() => {
            Griseado("/");
          }}
        >
          <img src={Logo} alt="" className="CCL" />
        </Link>
        {cliente ? (
          <img src={Menu} onClick={toggleMenu} className="burguer" />
        ) : (
          <>
            <span className="borrar">.</span>
          </>
        )}
      </header>

      <MobileMenu
        estado={estado}
        accion={toggleMenu}
        className="off"
      ></MobileMenu>

      {/* <div
        onClick={() => {
          Griseado("/carrito");
        }}
      >
        <ImgCarrito
          fill="white"
          Hover="white"
          width="50px"
          height="30px"
        ></ImgCarrito>
      </div> */}
    </>
  );
}

export default Header;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
